export default __webpack_public_path__ + "static/media/minus.d5a22d2a.png";